import Alpine from 'alpinejs'
import Splide from '@splidejs/splide'

import 'lite-youtube-embed'
import 'lite-vimeo-embed/module/lite-vimeo-embed'

import 'virtual:svg-icons-register'
import.meta.glob('../img/**/*')

const cardsSliderDefaults = {
  arrows: true,
  pagination: false,
  gap: '1.5rem',
  perPage: 3,
  perMove: 1,
  speed: 600,
  rewind: false,
  drag: true,
  breakpoints: {
    1024: {
      perPage: 2,
    },
    768: {
      perPage: 1,
    },
  },
}

export function init() {
  console.log('hello world!')
}

window.addEventListener('DOMContentLoaded', init)

window.Alpine = Alpine

Alpine.data('cardsSlider', (customOptions = {}) => ({
  splide: null,

  init() {
    const slider = this.$refs.slider

    if (!slider) {
      return
    }

    this.splide = new Splide(slider, {
      ...cardsSliderDefaults,
      ...customOptions,
      breakpoints: {
        ...cardsSliderDefaults.breakpoints,
        ...(customOptions.breakpoints ?? {}),
      },
    })

    this.splide.mount()
  },
}))

Alpine.start();

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR')
  })
}
